const listeners = new Set();

export function subscribeAppUpdate(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyServiceWorkerUpdate(registration) {
  listeners.forEach((listener) => {
    listener({ type: 'sw', registration });
  });
}
